export const quotes = [
  "Acknowledge me",
  "I'm a real gangster",
  "I run conglomerates",
  "Without me, an organisation big enough to be on the NASDAQ goes belly up",
  "I am the one who knocks",
  "Look at me, I'm the captain now",
  "I'm the final boss",
  "I'm a professional driver",
  "I'm a professional chef",
  "I run empires",
  "I run this house",
  "I'm going to buy Beverly Hills",
  "MAGA",
  "Trump is the best",
  "Trump is the best president in history",
  "Vote Reform",
  "I'm the baddest motherfucker of all time",
  "I'm the crackhead whisperer",
  "Disgusting",
  "I ain't got time",
  "Well done",
  "Dossers",
  "Hehehe",
  "I'm a proper hard kunt",
  "You think I'm a fuckin' joke?",
  "I'll show you what a joke is",
  "I'm a gangster",
  "Don't wanna fuck with me",
  "I pay for everything in that house",
  "I own that house",
  "I've created something from nothing",
  "Listen! Listen! Listen!",
  "You work for me",
  "I'm in charge",
  "Kunts",
  "I'm tellin' you naa!",
  "Fried food? You must be joking",
  "I'll kill you",
  "I'm not asking, I'm telling you",
  "I built this empire with my bare hands",
  "I make the decisions around here",
  "I am the main event",
  "I don't do weakness",
  "I'm levels above you lot",
  "I make grown men nervous",
  "I'm the boss, the brand, and the business",
  "I'm a chief, what are you?",
  "I will hurt you",
  "I've killed before",
  "The beater uppers will get you",
  "Watching and eating",
  "Meaty mighty",
];
